import { takeLatest, put, call } from 'redux-saga/effects';
import studentProgressService from '@/services/studentProgressService';
import {
    fetchLearningJourneyStart,
    fetchLearningJourneySuccess,
    fetchLearningJourneyFailure,
    fetchLearningTopicsStart,
    fetchLearningTopicsSuccess,
    fetchLearningTopicsFailure,
    fetchTodaySuggestionsStart,
    fetchTodaySuggestionsSuccess,
    fetchTodaySuggestionsFailure,
    fetchStatsStart,
    fetchStatsSuccess,
    fetchStatsFailure,
    fetchExploreTopicsStart,
    fetchExploreTopicsSuccess,
    fetchExploreTopicsFailure,
    fetchDailyProgressSuccess,
    fetchDailyProgressFailure,
    fetchDailyProgressStart,
    fetchWeeklyProgressSuccess,
    fetchWeeklyProgressFailure,
    fetchWeeklyProgressStart,
} from '@/store/slices/studentProgress/studentProgressSlice';
import { SagaIterator } from 'redux-saga';
import { PayloadAction } from '@reduxjs/toolkit';
import { ILearningTopicsGetListQuery } from '@/features/student/StudentProgress/types';

// Learning Journey
function* fetchLearningJourney() {
    try {
        const data = yield call(studentProgressService.getLearningJourney);
        yield put(fetchLearningJourneySuccess(data));
    } catch (error: any) {
        yield put(fetchLearningJourneyFailure(error.message));
    }
}

// Learning Topics
function* fetchLearningTopics(action: PayloadAction<ILearningTopicsGetListQuery>) {
    try {
        const data = yield call(studentProgressService.getLearningTopics, action.payload);
        yield put(fetchLearningTopicsSuccess(data));
    } catch (error: any) {
        yield put(fetchLearningTopicsFailure(error.message));
    }
}

function* fetchExploreTopics(action: PayloadAction<ILearningTopicsGetListQuery>) {
    try {
        const data = yield call(studentProgressService.getLearningTopics, action.payload);
        yield put(fetchExploreTopicsSuccess(data));
    } catch (error: any) {
        yield put(fetchExploreTopicsFailure(error.message));
    }
}

// Today Suggestions
function* fetchTodaySuggestions() {
    try {
        const data = yield call(studentProgressService.getTodaySuggestions);
        yield put(fetchTodaySuggestionsSuccess(data));
    } catch (error: any) {
        yield put(fetchTodaySuggestionsFailure(error.message));
    }
}

// Stats
function* fetchStats() {
    try {
        const data = yield call(studentProgressService.getStats);
        yield put(fetchStatsSuccess(data));
    } catch (error: any) {
        yield put(fetchStatsFailure(error.message));
    }
}

function* fetchDailyProgress() {
    try {
        const data = yield call(studentProgressService.getDailyProgress);
        yield put(fetchDailyProgressSuccess(data));
    } catch (error: any) {
        yield put(fetchDailyProgressFailure(error.message));
    }
}

function* fetchWeeklyProgress() {
    try {
        const data = yield call(studentProgressService.getWeeklyProgress);
        yield put(fetchWeeklyProgressSuccess(data));
    } catch (error: any) {
        yield put(fetchWeeklyProgressFailure(error.message));
    }
}

export default function* progressSaga(): SagaIterator {
    yield takeLatest(fetchLearningJourneyStart.type, fetchLearningJourney);
    yield takeLatest(fetchLearningTopicsStart.type, fetchLearningTopics);
    yield takeLatest(fetchExploreTopicsStart.type, fetchExploreTopics);
    yield takeLatest(fetchTodaySuggestionsStart.type, fetchTodaySuggestions);
    yield takeLatest(fetchStatsStart.type, fetchStats);
    yield takeLatest(fetchDailyProgressStart.type, fetchDailyProgress);
    yield takeLatest(fetchWeeklyProgressStart.type, fetchWeeklyProgress);
}
